import { render, staticRenderFns } from "./teacherInfo.vue?vue&type=template&id=41cd750c&scoped=true"
import script from "./teacherInfo.vue?vue&type=script&lang=js"
export * from "./teacherInfo.vue?vue&type=script&lang=js"
import style0 from "./teacherInfo.vue?vue&type=style&index=0&id=41cd750c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd750c",
  null
  
)

export default component.exports